export default {
  title: 'Home',
  'placeholder': 'English home page content',
  'Welcome to your new Gatsby site': 'Welcome to your new Gatsby site.',
  'Now go build something great': 'Now go build something great.',
  'or learn more': '...or learn more.',
  'Go to page 2': 'Go to page 2',

  'contactlink': 'Contact',
  'projlink': 'The Project',
  'reforestlink': 'Reforestation',
  'atlforestlink': 'Atlantic Forest',
  'zecarlink': 'ZéCar',
  'peoplelink': 'People',
  'toolslink': 'Tools',
  'manuallink': 'Manual',
  'treeslink': 'Trees Planted',
  'saplingslink': 'Saplings'

};
